// we need to maintain a fix order of vendors that will be called or the build will produce an error (as we have multiple entry points)
import 'assets/core/js/module/sliderManager'
import 'assets/core/js/module/selectManager'

import product from 'assets/core/js/entry/product'
import GoTop from 'assets/core/js/module/goTop'
import HashManager from 'assets/core/js/module/hashManager'
// import { initModal } from 'assets/core/js/module/paymentFacilities'
import dataLayer from 'assets/core/js/page/product/dataLayer'
import goBack from 'assets/core/js/page/product/goBack'
import presentation from 'assets/core/js/page/product/presentation'
import zoomMediasPanel from 'assets/core/js/page/product/zoomMediasPanel'
import faqToggle from 'assets/themes/campings/js/module/faqToggle'
import partials from 'assets/themes/campings/js/module/partials'
import bestOffer from 'assets/themes/campings/js/page/product/bestOffer'
import calendar from 'assets/themes/campings/js/page/product/calendar'
import facets from 'assets/themes/campings/js/page/product/facets'
import filters from 'assets/themes/campings/js/page/product/filters'
import imagesSliders from 'assets/themes/campings/js/page/product/imagesSliders'
import map from 'assets/themes/campings/js/page/product/map'
import shareModal from 'assets/themes/campings/js/page/product/modal/share'
import navigation from 'assets/themes/campings/js/page/product/navigation'
import properties from 'assets/themes/campings/js/page/product/properties'
import results from 'assets/themes/campings/js/page/product/results'
import reviews from 'assets/themes/campings/js/page/product/reviews'
import scrollToTarget from 'assets/themes/campings/js/page/product/scrollToTarget'
import search from 'assets/themes/campings/js/page/product/search'
import sidePanels from 'assets/themes/campings/js/page/product/sidePanels'

const productFacets = facets.init()
HashManager.init()

document.addEventListener('DOMContentLoaded', function () {
  product()

  sidePanels()
  // keep this call before the others non critical as it can trigger offers refresh
  search(productFacets)
  // Initialize partials after the search to prevent a double update.
  partials()

  // payment facilities modal
  // initModal()

  bestOffer()
  dataLayer('.result__card[data-id]')
  navigation()
  scrollToTarget()
  filters()
  shareModal()
  results()
  calendar()
  zoomMediasPanel()

  setTimeout(() => {
    imagesSliders()
    goBack()
    map()
    GoTop('.product__section.product__images')
    properties()
    presentation()
    reviews()
    faqToggle()
  }, 0)
})
